export function setupWizard() {
    const el = document.querySelector('.js-wizard')

    if (el) {
        import('./wizard')
            .then((m) => m.Wizard)
            .then((Wizard) => {
                Wizard(el, window.wizardQuestions)
            })
    }
}
